import Cookies from "js-cookie";

const $body = $(document.body)

if ($body.hasClass('page--pricing-new')) {
  ;(function() {
    const $pricingPage = $('.page--pricing-new')
    const $pricingTableContainer = $(
      '.pricing-new__plan-table-container',
      $pricingPage,
    )
    const $pricingTableHeadline = $(
      '.pricing-new__plan-table-headline-container',
      $pricingPage,
    )

    // Add the A/B testing cookie, expires 1 day (CACOO-21384)
    if ($body.hasClass('pricing-plan-new')) {
      Cookies.set('cacoo_signup_ab_testing', btoa('Three plan column'), { expires: 1 })
    } else {
      Cookies.set('cacoo_signup_ab_testing', btoa('Single column'), { expires: 1 })
    }


    $pricingTableHeadline.on('click', () => {
      if ($pricingTableContainer.hasClass('-hide')) {
        $pricingTableContainer.removeClass('-hide')
        return
      }
      $pricingTableContainer.addClass('-hide')
    })
  })()
}
